import axios from "axios";
import {
  getSupportConversationsUrl,
  getSupportMessagesUrl,
  sendSupportMessageUrl,
  markSupportReadUrl,
  assignSupportConversationUrl,
  setSupportStatusUrl,
} from "../utils/urls";

// params: { status?: 'open'|'pending'|'closed', mine?: 'true' }
export const getSupportConversations = async (params = {}) => {
  const res = await axios.get(getSupportConversationsUrl, { params });
  return res?.data?.data;
};

export const getSupportMessages = async (conversationId, params = {}) => {
  const res = await axios.get(getSupportMessagesUrl(conversationId), { params });
  return res?.data?.data;
};

export const sendSupportMessage = async ({ conversationId, body, file }) => {
  const formData = new FormData();
  formData.append("conversation_id", conversationId);
  if (body) formData.append("body", body);
  if (file) formData.append("attachment", file);
  const res = await axios.post(sendSupportMessageUrl, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res?.data?.data;
};

export const markSupportRead = async (conversationId) => {
  const res = await axios.patch(markSupportReadUrl(conversationId));
  return res?.data?.data;
};

export const assignSupportConversation = async (conversationId) => {
  const res = await axios.patch(assignSupportConversationUrl(conversationId));
  return res?.data?.data;
};

export const setSupportStatus = async (conversationId, status) => {
  const res = await axios.patch(setSupportStatusUrl(conversationId), { status });
  return res?.data?.data;
};
